import { useEffect, useRef } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import { useRouter } from 'components/common/RoutesProvider';

const useTrackPageViews = () => {
  const router = useRouter();
  const lastTrackedUrlRef = useRef<string | null>(null);

  useEffect(() => {
    if (!router) {
      return;
    }
    const initConfig = datadogRum.getInitConfiguration();
    if (!initConfig) {
      console.warn('Datadog RUM is not initialized.');
      return;
    }

    const simplifiedUrl = router.pathname;
    if (lastTrackedUrlRef.current === simplifiedUrl) return;

    lastTrackedUrlRef.current = simplifiedUrl;

    datadogRum.startView(simplifiedUrl);
  }, [router]);
};

export default useTrackPageViews;
